import {createReducer, on} from "@ngrx/store";
import * as DeviceActions from './device.actions';
import { initialDeviceState } from "./device.state";

export const deviceReducer = createReducer(
  initialDeviceState,

  // LOAD Devices
  on(DeviceActions.loadDevices, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(DeviceActions.loadDevicesSuccess, (state, { devices }) => ({
    ...state,
    loading: false,
    devices,
    loaded: true,
    lastLoadedAt: Date.now(),
  })),
  on(DeviceActions.loadDevicesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // REGISTER DEVICE
  on(DeviceActions.registerDevices, (state) => ({
    ...state,
    loading: true,
  })),
  on(DeviceActions.registerDevicesSuccess, (state, { devices }) => {
    const deviceIds = devices.map(d => d.id);
    const notRequestedDevices = state.devices.filter(d => !deviceIds.includes(d.id));
    return {
      ...state,
      loading: false,
      devices: [...notRequestedDevices, ...devices]
    };
  }),
  on(DeviceActions.registerDevicesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // REMOVE DEVICE
  on(DeviceActions.removeDevice, (state) => ({
    ...state,
    loading: true,
  })),
  on(DeviceActions.RemoveDeviceSuccess, (state, { deviceId }) => ({
    ...state,
    loading: false,
    devices: state.devices.filter((g) => g.id !== deviceId),
  })),
  on(DeviceActions.removeDeviceFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);